import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { AboutUs } from './components/AboutUs';
import { Programs } from './components/Programs';
import { Community } from './components/Community';
import { Blog } from './components/Blog';
import { Media } from './components/Media';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <AboutUs data-id="element-4" />
        <Programs data-id="element-5" />
        <Community data-id="element-6" />
        <Blog data-id="element-7" />
        <Media data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}